module.exports = {
    menuWrapper: "#menu-wrap",
    trigger: "#menu-trigger",
    menuId: "#myTopNav",
    aspMenuId: "#zz13_RootAspMenu, #zz2_RootAspMenu",
    headers: ".ms-core-listMenu-root > li.static > ul.static > li.dynamic-children",
    activeHeaders: ".ms-core-listMenu-root > li.static > ul.static > li.dynamic-children.active",
    dropdownMenu: "html.natp #menu-wrap ul.ms-core-listMenu-root > li.static > ul.static",
    dropdownLinks: ".ms-core-listMenu-root > li.static > ul.static > li.dynamic-children ul.dynamic a"
}


// WEBPACK FOOTER //
// ./src/scripts/components/topNav/selectors.js